






































































import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { Errors } from '@/dto/ErrorsResponse'
import { Routes } from '@/router/routes'
import Tax from '@/dto/taxes/Tax'
import taxesStore from '@/stores/TaxStore'
import LocationService from '@/services/LocationService'
import DictionariesService from '@/services/DictionariesService'
import Currency from '@/dto/deliveries/Currency'
import Country from '@/dto/deliveries/Country'
import TaxDeleteForm from '@/components/tax/TaxDeleteForm.vue'
import Hot from '@/services/hot/Hot'
import HotService from '@/services/HotService'

const hot = new Hot()

@Component({
  components: { TaxDeleteForm },
})
export default class TaxForm extends Vue {
  @Prop(Object)
  model: Tax

  countries: Country[] = []
  countriesOptions: any = null
  taxesStore = taxesStore
  isPending: boolean = false
  isShowConfirmDialog: boolean = false
  isDisabledBtn: boolean = true
  dictionaries = DictionariesService

  created() {
    LocationService.getCountries().then(countries => {
      this.countries = countries
      this.setCountriesOptions(countries)
      this.initHot()
    })
  }

  initHot(currencySymbol: string = '$') {
    if (this.model.id && this.model.currencyCode) {
      currencySymbol = this.dictionaries.currencies[this.model.currencyCode]
        .symbol
    }

    const config = HotService.getTaxesSettings(currencySymbol)

    hot.init(this.$refs.mountPoint as Element, config)
    hot.loadData(this.model.options)
    hot.addAfterChange(() => {
      this.isDisabledBtn = false
      this.model.options = hot.getData()
    })
    hot.hotInstance.updateSettings({ minSpareRows: 1 })
  }

  get errors(): Errors {
    return this.taxesStore.errors
  }

  async saveTax() {
    this.isPending = true
    const newTax = (await this.taxesStore.saveTax(this.model)) as Tax
    this.isPending = false

    if (this.model.id === null) {
      this.$router.push({
        name: Routes.taxEdit,
        params: { taxId: (newTax.id as number).toString() },
      })
    }
  }

  get country() {
    return this.countries.find(
      country => country.id === (this.model.fromCountryId as number)
    )
  }

  get currentCurrency(): Currency | null {
    if (!this.model.currencyCode) {
      return null
    }

    return this.dictionaries.currencies[this.model.currencyCode]
  }

  get currenciesOptions() {
    return this.dictionaries.getCurrenciesOptions()
  }

  filterCountries(query: string, update: Function, abort: Function) {
    if (query.length === 0) {
      abort()
      return
    }
    LocationService.getCountries().then(countries =>
      update(() => this.setCountriesOptions(countries, query))
    )
  }

  setCountriesOptions(countries: Country[], query: string = '') {
    this.countriesOptions = countries
      .filter(
        country =>
          country.name.toLowerCase().indexOf(query.toLowerCase()) !== -1
      )
      .map(country => ({
        label: country.name,
        value: country.id,
      }))
  }

  @Watch('model', { deep: true })
  watchFields(model: Tax, oldModel: Tax) {
    this.isDisabledBtn = model.id !== oldModel.id
    model.id &&
      model.currencyCode &&
      this.initHot(this.dictionaries.currencies[model.currencyCode].symbol)
  }
}
